import Image from 'next/image'
import WhyZenadmin from 'v1/page-components/marketing/free-trial/why-zenadmin/WhyZenadmin'
import WhyZenadminWhyNow from './WhyZenadminWhyNow'
import OperationalSupport from './OperationalSupport'
import {freeTrialProducts, topBenefitsData} from 'v1/content/marketing/free-trial'
import classes from './styles.module.css'
import clsx from 'clsx'

export default function MainSection() {
  return (
    <>
      <section className={classes.mainSectionContainer}>
        <WhyZenadminWhyNow />
      </section>

      <section className={classes.benifitListSection}>
        <div className={classes.benifitTopBox}>
          <h3 className="h3-v1">{freeTrialProducts.title}</h3>
          <p className="paragraph1-v1">{freeTrialProducts.subTitle}</p>
        </div>
        <div className={clsx(classes.benifitCardsContainer, classes.gap24)}>
          {freeTrialProducts?.list?.map((product, idx) => (
            <div key={idx} className={clsx(classes.productCard, classes[product.borderClass])}>
              <div
                className={clsx(
                  classes.productCardHeader,
                  classes[product.borderClass],
                  classes[product.bgClass],
                )}
              >
                <Image loading="lazy" width={40} height={40} src={product.icon} alt="icon" />
                <h4 className="h4-v1">{product.title}</h4>
              </div>
              <p className={clsx('paragraph2-v1', classes.productCardBox)}>{product.text}</p>
            </div>
          ))}
        </div>
      </section>
      <WhyZenadmin />

      <section className={classes.benifitListSection}>
        <div className={classes.benifitTopBox}>
          <h3 className="h3-v1">{topBenefitsData.title}</h3>
        </div>
        <div className={classes.benifitCardsContainer}>
          {topBenefitsData?.list?.map((benifit, idx) => (
            <div key={idx} className={classes.benifitCard}>
              <Image loading="lazy" src={benifit.icon} alt="icon" />
              <h5 className="h5-v1">{benifit.title}</h5>
              <p className={clsx('paragraph1-v1', classes.mt16)}>{benifit.text}</p>
            </div>
          ))}
        </div>
      </section>

      <section className={classes.mainSectionContainer}>
        <OperationalSupport />
      </section>
    </>
  )
}


export const BoldTextWithAsterisks = ({ text }: { text: string }) => {
  const regex = /\*(.*?)\*/g;

  const parts = text.split(regex).map((part, index) => {
    if (index % 2 !== 0) {
      return <strong className='strong-text' key={index}>{part}</strong>;
    }
    return part;
  });

  return <>{parts}</>;
};
